var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1015,
    height: 595,
    viewBox: "0 0 1015 595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#18d9af;}.b,.f,.l,.q,.t,.x{fill:none;}.c,.m{fill:#fff;}.d,.e,.o,.s,.w{fill:#161837;}.d{font-size:25px;}.d,.r,.w{font-family:OpenSans-Semibold, Open Sans;font-weight:600;}.e,.m,.n,.v{font-size:12px;}.e,.m,.n,.s,.v,.z{font-family:OpenSans, Open Sans;}.f{stroke:#00d480;stroke-width:3px;}.g{clip-path:url(#a);}.h{clip-path:url(#b);}.i{clip-path:url(#c);}.j{clip-path:url(#d);}.k,.n{fill:#3063d5;}.l{stroke:#3063d5;}.p,.z{fill:#f8f8fa;}.q{stroke:#eae9f7;}.q,.t{stroke-width:7px;}.r,.v{fill:#787ea0;}.r{font-size:14px;}.s{font-size:30px;}.t{stroke:#18d9af;stroke-linecap:round;stroke-miterlimit:10;}.ab,.u{fill:#eae9f7;}.w{font-size:15px;}.y{fill:#212631;opacity:0.431;}.z{font-size:20px;}.aa,.ab{stroke:none;}.ac{filter:url(#e);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10-24H30A10,10,0,0,1,40-14h0A10,10,0,0,1,30-4H10A10,10,0,0,1,0-14H0A10,10,0,0,1,10-24Z",
    transform: "translate(0 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-469,662.333H384.333V-191H-469Z",
    transform: "translate(469 191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.875-6.25a7.637,7.637,0,0,0,7.875-7.375A7.637,7.637,0,0,0,34.875-21,7.637,7.637,0,0,0,27-13.625,7.637,7.637,0,0,0,34.875-6.25Z",
    transform: "translate(-27 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-469,648.111H427V-191H-469Z",
    transform: "translate(469 191)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 235,
    y: 160.5,
    width: 280,
    height: 431.137,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-265 -201)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1015,
    height: 595,
    transform: "translate(265 201)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(310 238)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "Espaces")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 123)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(484 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tous")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(530 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Salles de r\xE9union")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(646 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Co-working")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(729 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bureaux")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(796 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Espaces au m2")), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 28,
    transform: "translate(483.5 196.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(584 75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(324 196)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-390.833 -139.167)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5-29H43.333V-.667H-5Z",
    transform: "translate(391.667 164)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(21.625 -21.375)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(-434 -139.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22-26H46.5V-3.056H22Z",
    transform: "translate(407.625 161.208)"
  })))), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(370 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Disponibles")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(266 187)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R\xE9serv\xE9s"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 85,
    height: 30,
    transform: "translate(851 145)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(850 145)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa",
    width: 169,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 0.5,
    width: 168,
    height: 29
  })), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(893 165)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.421,
    y: 0
  }, "Mois")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(977 165)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.144,
    y: 0
  }, "Semaine"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48 75)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(1184 235)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.41,
    y: 0
  }, "TRIM2 / Mai - Aout")), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M4,0,8,4.632H0Z",
    transform: "translate(1102 235) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M4,0,8,4.632H0Z",
    transform: "translate(1270.632 227) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-197 121)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 220,
    height: 189.137,
    transform: "translate(1187 267.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(1234 297)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 62.5,
    cy: 62.5,
    r: 62.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 62.5,
    cy: 62.5,
    r: 59
  })), /*#__PURE__*/React.createElement("text", {
    className: "r",
    transform: "translate(1281 253)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aout")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "s",
    transform: "translate(1266 371)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12%"))), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M60.21,230.405a59.025,59.025,0,1,0,39.443-15.112",
    transform: "translate(1196.869 85.207)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10207 2158)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 220,
    height: 189.137,
    transform: "translate(10507 -1769.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(10554 -1740)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 62.5,
    cy: 62.5,
    r: 62.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 62.5,
    cy: 62.5,
    r: 59
  })), /*#__PURE__*/React.createElement("text", {
    className: "r",
    transform: "translate(10605 -1784)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mai")), /*#__PURE__*/React.createElement("text", {
    className: "s",
    transform: "translate(10617 -1666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.925,
    y: 0
  }, "7%")), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M366.651,229.155c-9.676-6.856-23.113-11.1-37.966-11.1",
    transform: "translate(10284.314 -1955.052)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10307 2158)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "matrix(1, 0, 0, 1, 10572, -1957)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 220,
    height: 371.137,
    transform: "translate(265 187.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(10885 -1740)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 62.5,
    cy: 62.5,
    r: 62.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 62.5,
    cy: 62.5,
    r: 59
  })), /*#__PURE__*/React.createElement("text", {
    className: "r",
    transform: "translate(10935 -1784)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Juin")), /*#__PURE__*/React.createElement("text", {
    className: "s",
    transform: "translate(10918 -1666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21%")), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M137.261,215.293a60.636,60.636,0,0,1,60.693,60.693",
    transform: "translate(10808.739 -1952.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10699 -1866)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 297)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 184.057,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 148.057,
    height: 7,
    rx: 3.5,
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "v",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Salles de r\xE9union"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 184.057,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 120,
    height: 7,
    rx: 3.5,
    transform: "translate(64)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "v",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Co-working"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 371)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 184.057,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 55,
    height: 7,
    rx: 3.5,
    transform: "translate(129)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "v",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bureaux"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 408)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 184.057,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 178.057,
    height: 7,
    rx: 3.5,
    transform: "translate(6)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "v",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Espaces au m2"))), /*#__PURE__*/React.createElement("text", {
    className: "w",
    transform: "translate(342 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.051,
    y: 0
  }, "83%")), /*#__PURE__*/React.createElement("text", {
    className: "w",
    transform: "translate(342 347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.051,
    y: 0
  }, "46%")), /*#__PURE__*/React.createElement("text", {
    className: "w",
    transform: "translate(342 384)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.051,
    y: 0
  }, "22%")), /*#__PURE__*/React.createElement("text", {
    className: "w",
    transform: "translate(342 421)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.051,
    y: 0
  }, "99%")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10415 2158)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 220,
    height: 189.137,
    transform: "translate(11175 -1769.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(11222 -1740)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M62.5,0A62.5,62.5,0,1,1,0,62.5,62.5,62.5,0,0,1,62.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M 62.5 7 C 31.89720153808594 7 7 31.89720153808594 7 62.5 C 7 93.10279846191406 31.89720153808594 118 62.5 118 C 93.10279846191406 118 118 93.10279846191406 118 62.5 C 118 31.89720153808594 93.10279846191406 7 62.5 7 M 62.5 0 C 97.01779174804688 0 125 27.98220825195312 125 62.5 C 125 97.01779174804688 97.01779174804688 125 62.5 125 C 27.98220825195312 125 0 97.01779174804688 0 62.5 C 0 27.98220825195312 27.98220825195312 0 62.5 0 Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "r",
    transform: "translate(11267 -1784)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Juillet")), /*#__PURE__*/React.createElement("text", {
    className: "s",
    transform: "translate(11256 -1666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "36%")), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M207.36,215.293a58.486,58.486,0,0,1,50.3,88.3",
    transform: "translate(11077.64 -1951.293)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 1015,
    height: 595,
    transform: "translate(265 201)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(671 485)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "z",
    transform: "translate(-28 21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "En cours de d\xE9veloppement"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5fe3f6e2e769fce99f0073614ce94339.svg";
export { ForwardRef as ReactComponent };